import { Card, Input, Typography } from "antd";
import { Mail, Phone, User, Shield } from "lucide-react";
import PageMeta from "~/components/common/meta";
import { useAuth } from "~/store";
import { Role } from "~/utils/constants";

const { Title, Text } = Typography;

const getRoleLabel = (role?: Role) => {
  switch (role) {
    case Role.SUPER_ADMIN:
      return "Super Admin";
    case Role.ADMIN:
      return "Admin";
    case Role.LEAD:
      return "Lead";
    default:
      return role || "Unknown";
  }
};

export function ScreenAdminProfile() {
  const { user } = useAuth();

  if (!user) {
    return <div>No user data available</div>;
  }

  const fullName =
    `${user.firstName || ""} ${user.lastName || ""}`.trim() || user.username;

  return (
    <>
      <PageMeta title="Profile | Art Handler" />
      <div className="space-y-3 md:space-y-4">
        <Title level={3} className="mb-0 text-lg md:text-xl">
          My Profile
        </Title>

        <Card
          classNames={{ body: "p-0" }}
          className="mb-3 md:mb-4 xl:mb-6 border-0 md:border"
        >
          <div className="p-3 md:p-4 xl:p-5 border-b">
            <Text strong className="text-sm md:text-base xl:text-lg">
              Account Information
            </Text>
          </div>
          <div className="p-3 md:p-4 xl:p-5">
            <div className="flex items-center mb-4 md:mb-6 gap-3 md:gap-4">
              <div className="w-16 h-16 md:w-20 md:h-20 xl:w-24 xl:h-24 bg-gray-200 rounded-full flex items-center justify-center flex-shrink-0">
                <User size={24} className="md:size-8 xl:size-9 text-gray-400" />
              </div>
              <div className="flex-1 min-w-0">
                <Title
                  level={4}
                  className="text-base md:text-lg xl:text-xl mb-1"
                >
                  {fullName}
                </Title>
                <div className="flex items-center gap-1.5">
                  <Shield size={14} className="text-gray-400" />
                  <Text type="secondary" className="text-sm md:text-base">
                    {getRoleLabel(user.role)}
                  </Text>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 md:gap-6">
              <div className="space-y-3 md:space-y-4">
                <div>
                  <Text
                    type="secondary"
                    className="text-xs md:text-sm block mb-1"
                  >
                    Username
                  </Text>
                  <Input
                    prefix={
                      <User size={14} className="md:size-4 text-gray-400" />
                    }
                    value={user.username}
                    readOnly
                    size="large"
                  />
                </div>
                <div>
                  <Text
                    type="secondary"
                    className="text-xs md:text-sm block mb-1"
                  >
                    Email
                  </Text>
                  <Input
                    prefix={
                      <Mail size={14} className="md:size-4 text-gray-400" />
                    }
                    value={user.email ?? ""}
                    readOnly
                    size="large"
                  />
                </div>
                <div>
                  <Text
                    type="secondary"
                    className="text-xs md:text-sm block mb-1"
                  >
                    Phone
                  </Text>
                  <Input
                    prefix={
                      <Phone size={14} className="md:size-4 text-gray-400" />
                    }
                    value={user.phoneNumber ?? ""}
                    readOnly
                    size="large"
                  />
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </>
  );
}
